import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./components/auth/Login";
import CompanyDetail from "./components/companies/CompanyDetail";
import Signup from "./components/auth/Signup";
import Dashboard from "./components/Dashboard";
import AgentList from "./components/agents/AgentList";
import ConversationList from "./components/conversations/ConversationList";
import KnowledgeBaseList from "./components/knowledge/KnowledgeBaseList";
import ContactList from "./components/contacts/ContactList";
import ContactBunchList from "./components/contacts/ContactBunchList";
import BatchCallList from "./components/batch/batchCallList";
import Sidebar from "./components/layout/Sidebar";
import PhoneNumberList from "./components/phoneNumbers/PhoneNumberList";
import CompanyMasterWithBranches from "./components/company/CompanyMasterWithBranches";
import "./App.css";
import OfferManagement from "./components/offers/OfferManagement";
import ProductManagement from "./components/products/ProductManagement";
import ProductForm from "./components/products/ProductForm";
import ProductList from "./components/products/ProductList";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { AuthProvider, useAuth } from "./context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Header from "./components/layout/Header";

function AppContent() {
  const { user, loading, login, logout } = useAuth();
 const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768);

  const toggleCollapsed = () => {
    // On desktop, maybe you want the collapse toggle too? But you had condition only mobile
    setCollapsed((prev) => !prev);
  };

  // Resize listener
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      if (mobile) {
        setCollapsed(true);
      } else {
     
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);
    // Call immediately to set correct for initial render
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close sidebar on navigation if mobile
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [location, isMobile]);


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <section id="main-box">
      {user && (
        <div className="container-box">
          <Sidebar
            onLogout={logout}
            collapsed={collapsed}
            onToggle={toggleCollapsed}
            isMobile={isMobile}
          />
          <div className="right-sidebar">
            <Header collapsed={collapsed} toggleCollapsed={toggleCollapsed} isMobile={isMobile} />
            <div>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/agents" element={<AgentList />} />

                  <Route path="/conversations" element={<ConversationList />} />

                  <Route
                    path="/knowledge-base"
                    element={<KnowledgeBaseList />}
                  />
                  <Route path="/contacts" element={<ContactList />} />
                  <Route path="/batch-calls" element={<BatchCallList />} />

                  <Route
                    path="/companies"
                    element={<CompanyMasterWithBranches />}
                  />
                  <Route path="/company-detail" element={<CompanyDetail />} />
                  <Route path="/phone-numbers" element={<PhoneNumberList />} />
                  <Route
                    path="/products"
                    element={<ProductManagement companyId={user.company_id} />}
                  />
                  <Route path="/offers" element={<OfferManagement />} />
                </Routes>
              </Layout>
            </div>
          </div>
        </div>
        // <Layout style={{ minHeight: "100vh" }}>
        //   <Sidebar onLogout={logout} collapsed={collapsed} />
        //   <Layout>
        //     <Content className="main-content">
        //       <Routes>
        //         <Route path="/" element={<Dashboard />} />
        //         <Route path="/agents" element={<AgentList />} />
        //         <Route path="/conversations" element={<ConversationList />} />
        //         <Route path="/knowledge-base" element={<KnowledgeBaseList />} />
        //         <Route path="/contacts" element={<ContactList />} />
        //         <Route path="/batch-calls" element={<BatchCallList />} />
        //         <Route
        //           path="/companies"
        //           element={<CompanyMasterWithBranches />}
        //         />
        //         <Route path="/company-detail" element={<CompanyDetail />} />
        //         <Route path="/phone-numbers" element={<PhoneNumberList />} />
        //         <Route
        //           path="/products"
        //           element={<ProductManagement companyId={user.company_id} />}
        //         />
        //         <Route path="/offers" element={<OfferManagement />} />
        //       </Routes>
        //     </Content>
        //   </Layout>
        // </Layout>
      )}
      {!user && (
        <Routes>
          <Route path="/login" element={<Login onLogin={login} />} />
          <Route path="/signup" element={<Signup onLogin={login} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </section>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
